/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_FiltersInputs */

const en_apply_filters = /** @type {(inputs: Apply_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply Filters (`)
};

const es_apply_filters = /** @type {(inputs: Apply_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar filtros (`)
};

const fr_apply_filters = /** @type {(inputs: Apply_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appliquer les filtres (`)
};

const de_apply_filters = /** @type {(inputs: Apply_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter anwenden (`)
};

const ja_apply_filters = /** @type {(inputs: Apply_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`絞り込みを適用 (`)
};

const zh_apply_filters = /** @type {(inputs: Apply_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应用筛选 (`)
};

const ar_apply_filters = /** @type {(inputs: Apply_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تطبيق التصفية (`)
};

const id_apply_filters = /** @type {(inputs: Apply_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terapkan Filter (`)
};

const it_apply_filters = /** @type {(inputs: Apply_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applica Filtri (`)
};

const ru_apply_filters = /** @type {(inputs: Apply_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Применить фильтры (`)
};

const pt_apply_filters = /** @type {(inputs: Apply_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar Filtros (`)
};

const ko_apply_filters = /** @type {(inputs: Apply_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`필터 적용 (`)
};

/**
* | output |
* | --- |
* | "Apply Filters (" |
*
* @param {Apply_FiltersInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const apply_filters = /** @type {((inputs?: Apply_FiltersInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_FiltersInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_apply_filters(inputs)
	if (locale === "es") return es_apply_filters(inputs)
	if (locale === "fr") return fr_apply_filters(inputs)
	if (locale === "de") return de_apply_filters(inputs)
	if (locale === "ja") return ja_apply_filters(inputs)
	if (locale === "zh") return zh_apply_filters(inputs)
	if (locale === "ar") return ar_apply_filters(inputs)
	if (locale === "id") return id_apply_filters(inputs)
	if (locale === "it") return it_apply_filters(inputs)
	if (locale === "ru") return ru_apply_filters(inputs)
	if (locale === "pt") return pt_apply_filters(inputs)
	return ko_apply_filters(inputs)
});